import { gql } from '@apollo/client';

export const OfferListingFragment = gql`
  fragment OfferListingDetail on OfferListingType {
    _id
    buyerDestinationName
    buyerProposedQuantity
    buyerProposedTotalPrice
    buyerSiteId
    buyerSiteName
    conversionRate
    costRecoveryRate
    createdAt
    currencyType
    destinationType
    discountRate
    exportRunId
    exportStatus
    ftpImportUsername
    importedCurrencyTotalPrice
    importedCurrencyType
    inventoryId
    listingId
    logisticsRelationshipName
    logisticsTerm
    negotiationListingId
    negotiationStatus
    offerId
    originalQuantity
    originalTotalPrice
    poNumber
    postAwardUpdates {
      awardedTotalPrice
      awardedQuantity
      buyerUpdatedTotalPrice
      buyerUpdatedQuantity
      status
    }
    priceOfInventoryAwarded
    pricingUOM
    pricingDivisor
    quantity
    requestedDeliveryDate
    reserveAnchor
    reserveNumber
    sellerSiteName
    status
    tags
    totalPrice
    transactionCycleId
    transactionLocationId
    unitPriceRecoveryRate
    weightUnit
    writeOffDiscountPercentage
    suggestedUnitPrice
    trucklaneDistance
    trucklaneCost
    suggestions {
      award {
        suggested
        quantity
      }
      negotiation {
        unitPrice
        recommended
        reason
        quantity
      }
      reservePriceException {
        suggested
        quantity
        isException
        reason
      }
    }
    isVendorOfRecord
    negotiation {
      _id
      origin
      status
      suggestedUnitPrice
      suggestedQuantity
      stagedUnitPrice
      stagedQuantity
      buyerResponseUnitPrice
      buyerResponseQuantity
      pricingStrategy
      percentageModifier
      reason
      archived
    }
  }
`;

export const OfferListingRecalcFragment = gql`
  fragment OfferListingRecalcDetail on OfferListingType {
    _id
    buyerDestinationName
    buyerProposedQuantity
    buyerProposedTotalPrice
    buyerSiteId
    buyerSiteName
    buyerDestinationId
    conversionRate
    costRecoveryRate
    createdAt
    currencyType
    destinationType
    discountRate
    exportRunId
    exportStatus
    ftpImportUsername
    importedCurrencyTotalPrice
    importedCurrencyType
    inventoryId
    listingId
    logisticsRelationshipName
    logisticsTerm
    negotiationListingId
    negotiationStatus
    offerId
    originalQuantity
    originalTotalPrice
    originalOfferListingId
    poNumber
    postAwardUpdates {
      awardedTotalPrice
      awardedQuantity
      buyerUpdatedTotalPrice
      buyerUpdatedQuantity
      status
    }
    priceOfInventoryAwarded
    pricingUOM
    pricingDivisor
    quantity
    requestedDeliveryDate
    reserveAnchor
    reserveNumber
    sellerSiteName
    status
    sellerLocationId
    tags
    totalPrice
    transactionCycleId
    transactionLocationId
    unitPriceRecoveryRate
    weightUnit
    writeOffDiscountPercentage
    suggestedUnitPrice
    trucklaneDistance
    trucklaneCost
    truckType
    suggestions {
      award {
        suggested
        quantity
      }
      negotiation {
        unitPrice
        recommended
        reason
        quantity
      }
      reservePriceException {
        suggested
        quantity
        isException
        reason
      }
    }
    activeTruckLane {
      _id
    }
    isVendorOfRecord
    negotiation {
      _id
      origin
      status
      suggestedUnitPrice
      suggestedQuantity
      stagedUnitPrice
      stagedQuantity
      buyerResponseUnitPrice
      buyerResponseQuantity
      pricingStrategy
      percentageModifier
      reason
      archived
    }
  }
`;
